import { Button } from "primereact/button";
import localeText from "../../../../../../locale";

const SecurityValidationFooter = ({ onCancel, onValidate, canValidate, validating, disabled }) => (
  <div className="security-validation-footer">
    <Button
      type="button"
      label={localeText("cancel")}
      className="p-button-outlined p-no-outline security-validation-cancel"
      onClick={onCancel}
      disabled={disabled}
    />
    <Button
      type="button"
      label={localeText("securityValidationValidate")}
      className="p-no-outline border-none security-validation-validate"
      onClick={onValidate}
      disabled={!canValidate}
      loading={validating}
    />
  </div>
);

export default SecurityValidationFooter;
